<div id="{{'case-search-results-row-'+  caseRowIndex + '-case-pleadings-issues-container'}}"
    class="table-responsive" *ngIf="gridType==='table' && pleadingTableDataList"
    appAnimateOpen [isOpen]="(rowBeingShown && !rowToBeHidden)" [maxDisplayRows]="maxDisplayRows">
  <table id="{{'case-search-results-row-'+  caseRowIndex + '-case-pleadings-issues-table'}}" 
         class="table table-fixedheader table-hover table-condensed table-nowrap">
    <thead id="{{'case-search-results-row-'+  caseRowIndex + '-pleadings-issues-table-header'}}">
      <tr id="{{'case-search-results-row-'+  caseRowIndex + '-pleadings-issues-table-header-tr'}}">
      <th *ngFor="let header of pleadingTableColumnHeaders;" width="{{header.headerWidth}}"><span *ngIf="header.vcode" class="field-code">{{header.vcode}} </span>{{header.headerName}} 
          <span *ngIf="header.popoverShow" popover="{{header.popoverContent}}" popoverTitle="{{header.popoverTitle}}" 
          placement="top" (click)="$event.stopPropagation()" title="">
          <i class="fa fa-info-circle"></i></span></th>
      </tr>
    </thead>
    <tbody id="{{'case-search-results-row-'+  caseRowIndex + '-case-pleadings-issues-table-tbody'}}" 
           [class.default-bgcolor]="!bgHighlighted"
           [class.highlighted-bgcolor]="true"
           [class.scroll-overflow-y]="scrollbarShouldBeShown()">
      <tr  id="{{'case-search-results-row-'+  caseRowIndex + '-case-pleadings-issues-row-' + k +'-table-tr'}}" 
           *ngFor="let pleadingItem of pleadingTableDataList; let k = index">
        <td id="{{'case-search-results-row-'+  caseRowIndex + '-case-pleadings-issues-row-' + k + '-pleading-clock-on' }}"
            width="{{pleadingTableColumnWidths[0]}}">
           <span title="{{pleadingItem.pleadingClockDate | date:'MM/dd/yyyy'}}">{{pleadingItem.pleadingClockDate | date:'MM/dd/yyyy'}}</span></td>
        <td id="{{'case-search-results-row-'+  caseRowIndex + '-case-pleadings-issues-row-' + k + '-pleading' }}"
             width="{{pleadingTableColumnWidths[1]}}">
           <span title="{{pleadingItem.pleadingType}}">{{pleadingItem.pleadingType}}</span></td>
        <td id="{{'case-search-results-row-'+  caseRowIndex + '-case-pleadings-issues-row-' + k + '-issue' }}"
             width="{{pleadingTableColumnWidths[2]}}">
           <span title="{{pleadingItem.pleadingIssueType}}">{{pleadingItem.pleadingIssueType}}</span></td>
       </tr>
       <tr *ngIf="(pleadingTableDataList.length ===0)">
         <td width="100%" colspan="3"><span>No pleadings and issues.</span></td> 
       </tr> 
    </tbody>
  </table>
</div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-search-results-pleads-grid/civil-search-results-pleads-grid.component.html